import type { Profile } from '@/lib/types';

export type RoleFilter = 'all' | 'admin' | 'member';

export function isAdminRole(role: string): boolean {
  return role === 'admin';
}

export function roleCounts(profiles: Profile[]) {
  const admin = profiles.filter((p) => isAdminRole(p.role)).length;
  return { all: profiles.length, admin, member: profiles.length - admin };
}

export function filterUsers(profiles: Profile[], roleFilter: RoleFilter, search: string): Profile[] {
  const q = search.trim().toLowerCase();
  return profiles.filter((p) => {
    const admin = isAdminRole(p.role);
    if (roleFilter === 'admin' && !admin) return false;
    if (roleFilter === 'member' && admin) return false;
    if (!q) return true;
    return (p.display_name || '').toLowerCase().includes(q) || (p.email || '').toLowerCase().includes(q);
  });
}
